var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevalexFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 630 310",
    viewBox: "0 0 593.54797 77.999001",
    height: 40,
    width: 136,
    y: "0px",
    x: "0px",
    id: "Layer_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata23"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs21"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20.521,-117.691)",
    id: "g16"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#243B53"
    },
    id: "path2",
    d: "m 102.217,155.346 c 0,11.283 -3.622,20.625 -10.871,28.021 -7.244,7.396 -16.47,11.092 -27.679,11.092 H 20.521 v -76.541 h 43.147 c 11.279,0 20.525,3.437 27.739,10.308 7.208,6.877 10.81,15.91 10.81,27.12 z m -13.336,1.122 c 0,-7.396 -2.37,-13.447 -7.113,-18.156 -4.749,-4.704 -10.78,-7.063 -18.1,-7.063 H 33.746 v 49.875 h 29.921 c 7.32,0 13.351,-2.28 18.1,-6.838 4.744,-4.557 7.114,-10.495 7.114,-17.818 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#243B53"
    },
    id: "path4",
    d: "m 179.21,194.458 h -66.123 v -76.541 h 66.123 v 13.331 h -52.786 v 49.875 h 52.786 z m -3.476,-32.165 h -43.707 v -13.338 h 43.707 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#243B53"
    },
    id: "path6",
    d: "m 290.824,117.917 -43.706,70.261 c -3.059,5.012 -5.825,7.512 -8.29,7.512 -2.395,0 -5.116,-2.5 -8.181,-7.512 l -42.81,-70.261 h 17.145 l 34.183,56.816 34.515,-56.816 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#243B53"
    },
    id: "path8",
    d: "m 362.103,194.458 -17.149,-0.116 -34.178,-56.7 -34.515,56.7 h -17.149 l 41.578,-69.14 c 1.046,-1.796 2.505,-3.435 4.371,-4.929 2.244,-1.72 4.261,-2.582 6.052,-2.582 1.942,0 3.959,0.82 6.052,2.466 1.791,1.423 3.25,3.104 4.371,5.045 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#243B53"
    },
    id: "path10",
    d: "M 435.775,194.458 H 369.763 V 117.917 H 383.1 v 63.206 h 52.676 v 13.335 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#243B53"
    },
    id: "path12",
    d: "m 511.863,194.458 h -66.116 v -76.541 h 66.116 v 13.331 h -52.782 v 49.875 h 52.782 z m -3.471,-32.165 h -43.711 v -13.338 h 43.711 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#243B53"
    },
    id: "path14",
    d: "m 614.069,194.569 h -19.167 l -27.004,-27.906 -26.894,27.906 h -19.166 l 37.205,-38.213 -37.205,-38.439 h 18.492 l 27.567,28.242 27.567,-28.242 h 18.604 l -37.321,38.439 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevalexFooterLogo);
export default __webpack_public_path__ + "static/media/devalex_footer_logo.7e190955.svg";
export { ForwardRef as ReactComponent };